export default __webpack_public_path__ + "static/media/phppgadmin-icon.28ff2c63.svg";